import {
  StyledTopbar,
  StyledTopbarAvatar,
  StyledTopbarContainer,
} from './Topbar.style';
import Lifebuoy from './Lifebuoy/Lifebuoy';
import AvatarPopover from './AvatarPopover/AvatarPopover';
import { GitstreamLogo } from '../../base/GitstreamLogo/GitstreamLogo';

const Topbar = props => {
  const {
    username,
    email,
    imageUrl,
    orgs,
    provider,
    container,
    onOrgSelected,
    onLogoutClick,
    sticky,
    top,
    beta,
    Logo = <GitstreamLogo beta={beta} />,
    HelpCenter = <Lifebuoy />,
    showHelpCenter = true,
  } = props;
  return (
    <StyledTopbar sticky={sticky} top={top}>
      {Logo}
      <StyledTopbarContainer>{container}</StyledTopbarContainer>
      <StyledTopbarAvatar>
        {showHelpCenter && HelpCenter}
        {orgs && (
          <AvatarPopover
            username={username}
            email={email}
            imageUrl={imageUrl}
            orgs={orgs}
            provider={provider}
            onOrgSelected={onOrgSelected}
            onLogoutClick={onLogoutClick}
          />
        )}
      </StyledTopbarAvatar>
    </StyledTopbar>
  );
};

export default Topbar;
